$.fn.PositionHover = function() {
  let self = this

  if (self.data('position-hover')) {
    return self.data('position-hover')
  }

  self.moved = function(e) {
    let left = (e.pageX - self.offset().left) / self.outerWidth(false),
    top = (e.pageY - self.offset().top) / self.outerHeight(false)
    self.removeModifier('top-left top-right bottom-right bottom-left')
    self.off('mousemove', self.moved)
    if (left < .5 && top < .5) {
      self.addModifier('top-left')
    } else if (left >= .5 && top < .5) {
      self.addModifier('top-right')
    } else if (left >= .5 && top >= .5) {
      self.addModifier('bottom-right')
    } else if (left < .5 && top >= .5) {
      self.addModifier('bottom-left')
    }
  }

  self.left = function() {
    self.on('mousemove', self.moved)
  }

  return function() {
    self.BlockElement()
    self.data('position-hover', self)
    self.on('mousemove', self.moved)
    self.on('mouseleave', self.left)
    return self
  }()
}
